// this function assumes that data is already sorted into the appropriate chronological (or other) order,
//  both in terms of the ordering of segments and the ordering within segments
export const segmentList = (data, getSegmentLabelFromItem) => {
    const segments = [];
    for (const item of data) {
        const label = getSegmentLabelFromItem(item);
        if (!segments.length || segments[segments.length - 1].label !== label) {
            // if this is the first record, or the label is different to it's predecessor, it is a new segment
            const thisSegment = { label, data: [] };
            segments.push(thisSegment);
        }
        segments[segments.length - 1].data.push(item);
    }
    return {
        segments,
    };
};
export const toGroupedSelectList = (list, keys) => {
    const { id, name, group } = keys;
    const start = [];
    const groupedList = list.reduce((acc, curr) => {
        const existingGroup = acc.find(x => x.group === curr[group]);
        if (!!existingGroup) {
            return [
                ...acc.filter(x => x.group !== curr[group]),
                { group: curr[group], groupItems: [...existingGroup.groupItems, curr] },
            ];
        }
        return [...acc, { group: curr[group], groupItems: [curr] }];
    }, start);
    const getNumericalSort = (x) => {
        const regEx = /(\d+)[^\d]*$/;
        const res = regEx.exec(x);
        const finalMatch = (res === null || res === void 0 ? void 0 : res.pop()) || "0";
        return parseInt(finalMatch);
    };
    const sortedGroupList = groupedList
        .map(x => {
        return {
            group: x.group,
            groupItems: x.groupItems.sort((a, b) => getNumericalSort(a[id]) > getNumericalSort(b[id]) ? 1 : -1),
        };
    })
        .sort((a, b) => a.group.localeCompare(b.group));
    return sortedGroupList.reduce((acc, curr) => {
        const mappedGroupItems = curr.groupItems.map(x => {
            return Object.assign(Object.assign({}, x), { id: x[id], name: x[name] });
        });
        return [...acc, { isGroup: curr.group }, ...mappedGroupItems];
    }, []);
};
